import React from "react";
import { connect } from "react-redux";
import { getUserCandybarPurchases, getUserId } from "../../reducers";
import { userCandybarPurchasesFetch } from "../../actions/creators/user";
import moment from "moment";
import Confirmation from "../checkout/Confirmation/Confirmation";
import styled from "styled-components";
import { breakpoints } from "../../utils/styles";
import CouponWindow from "./coupons/CouponWindow";
import Button from "../Button";
import "../checkout/Confirmation/Confirmation.css";

const Title = styled.h3`
    border-bottom: 1px solid var(--text-primary);
    padding-bottom: 0.75em;
    margin: 1em 0 0.5em;

    @media screen and (min-width: ${breakpoints.desktop}px) {
        font-size: 1.5rem !important;
    }
`;

const Table = styled.table`
    width: 100%;

    th {
        text-transform: uppercase;
        font-weight: 700;
    }

    th, td {
        padding: 1em 0;
    }
`;

const TableRow = styled.tr`
    cursor: pointer;
    
    @media screen and (min-width: ${breakpoints.desktop}px) {
        &:hover { font-weight: 700; }
    }
`;

const NoOrdersMessage = styled.p`
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1;
    margin: 1rem auto 3rem;
    max-width: 500px;
    text-align: center;
`;

const Emoji = styled.span`
    font-size: 3.5rem;
    display: block;
    margin: 1rem auto;
    // font-family: "Noto Color Emoji", sans-serif;
`;

interface Props {
    isLoading: boolean;
    userId: string;
    purchases: any[];
    fetch: () => void;
}

class UserCandybarPurchases extends React.Component<Props> {
    state = {
        selectedPurchase: null as any | null,
    };

    setSelectedPurchase = (purchase: any) => {
        this.setState({ selectedPurchase: purchase });
    };
    componentDidMount() {
        if (!this.props.purchases) {
            this.props.fetch();
        }
    }

    render() {
        if (!this.props.userId || this.props.purchases === null) {
            return null;
        }

        return <div>
            {this.props.purchases.length < 1
                ? this.renderNoPurchasesMessage()
                : this.renderPurchasesTable()}
            {this.state.selectedPurchase && <div className="confirmation-container">
                <CouponWindow desktopModal onClose={() => this.setSelectedPurchase(null)} title="Detalle de compra">
                    <div className="container pad-y">
                        <Confirmation data={this.state.selectedPurchase}/>
                    </div>
                </CouponWindow>
            </div>}
        </div>;
    }

    renderNoPurchasesMessage() {
        return <div className="text-center">
            <Emoji>🥤</Emoji>
            <NoOrdersMessage>Parece que aún no tienes compras en dulcería.</NoOrdersMessage>
            <Button block to="/dulceria" className="mb-3">¡Anticipa tu pedido!</Button>
        </div>;
    }

    renderPurchasesTable() {
        return <div>
            <p>Encuentra aquí tus compras hechas en Dulcería. Da click para ver detalle.</p>

            <Title className="title-2">Historial de compras</Title>

            <Table>
                <thead>
                    <tr>
                        <th>Fecha</th>
                        <th>Complejo</th>
                        <th>Total</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {this.props.purchases.map((purchase, index) => (
                        <TableRow key={index} onClick={() => this.setSelectedPurchase(purchase)}>
                            <td>{purchase.purchase_date ? moment.unix(purchase.purchase_date).format("DD/MM/YY") : ""}</td>
                            <td>{purchase.cinema ? purchase.cinema.name : '-'}</td>
                            <td>${(purchase.total / 100).toFixed(2)}</td>
                            <td><i className="fal fa-chevron-right"></i></td>
                        </TableRow>
                    ))}
                </tbody>
            </Table>
        </div>;
    }
}

const mapStateToProps = state => ({
    userId: getUserId(state),
    purchases: getUserCandybarPurchases(state),
});

const mapDispatchToProps = dispatch => ({
    fetch: () => dispatch(userCandybarPurchasesFetch()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserCandybarPurchases);